import type { Component } from 'solid-js';

/** Fullscreen loader between screens: Figma "Loader default" (Landing Tai Chi NEW, 667:10179) — grey track + spinning arc. */
export const Loader: Component<{ label?: string }> = (props) => (
  <div class="preloader" role="status" aria-live="polite" aria-label={props.label ?? 'Loading'}>
    <svg class="loader" viewBox="0 0 48 48" aria-hidden="true">
      <circle class="loader__track" cx="24" cy="24" r="20" />
      <circle class="loader__spin" cx="24" cy="24" r="20" />
    </svg>
  </div>
);
